import React, { useState } from 'react';
import FeedbackForm from './FeedbackForm';
import { getFeedbackStats } from '../api';

const FeedbackSidebar = ({ isOpen, onClose }) => {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  // Load stats when sidebar opens
  React.useEffect(() => {
    if (isOpen) {
      loadStats();
    }
  }, [isOpen]);

  const loadStats = async () => {
    try {
      setLoading(true);
      const data = await getFeedbackStats();
      setStats(data);
    } catch (err) {
      console.error('Failed to load feedback stats:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleFeedbackSuccess = () => {
    // Reload stats after successful feedback submission
    loadStats();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Sidebar */}
      <div className="feedback-sidebar">
        {/* Header */}
        <div className="feedback-sidebar__header">
          <div className="feedback-sidebar__header-content">
            <h2 className="feedback-sidebar__title">Feedback & Support</h2>
            <button
              onClick={onClose}
              className="feedback-sidebar__close-btn"
            >
              <svg className="feedback-sidebar__close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              Close Feedback
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="feedback-sidebar__content">
          {/* Quick Stats */}
          <div className="feedback-sidebar__stats">
            <h3 className="feedback-sidebar__stats-title">Feedback Overview</h3>
            {loading ? (
              <div className="feedback-sidebar__loading">
                <div className="feedback-sidebar__spinner"></div>
              </div>
            ) : stats ? (
              <div className="feedback-sidebar__stats-list">
                <div className="feedback-sidebar__stats-item">
                  <span className="feedback-sidebar__stats-label">Total:</span>
                  <span className="feedback-sidebar__stats-value">{stats.total_feedback}</span>
                </div>
                <div className="feedback-sidebar__stats-item">
                  <span className="feedback-sidebar__stats-label">Open:</span>
                  <span className="feedback-sidebar__stats-value">{stats.by_status?.open || 0}</span>
                </div>
                <div className="feedback-sidebar__stats-item">
                  <span className="feedback-sidebar__stats-label">In Progress:</span>
                  <span className="feedback-sidebar__stats-value">{stats.by_status?.in_progress || 0}</span>
                </div>
                <div className="feedback-sidebar__stats-item">
                  <span className="feedback-sidebar__stats-label">Resolved:</span>
                  <span className="feedback-sidebar__stats-value">{stats.by_status?.resolved || 0}</span>
                </div>
              </div>
            ) : (
              <p className="feedback-sidebar__stats-empty">No feedback data available</p>
            )}
          </div>

          {/* Quick Actions */}
          <div className="feedback-sidebar__actions">
            <h3 className="feedback-sidebar__actions-title">Quick Actions</h3>
            
            <button
              onClick={() => setShowFeedbackForm(true)}
              className="feedback-sidebar__action-btn feedback-sidebar__action-btn--primary"
            >
              <svg className="feedback-sidebar__action-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Submit Feedback
            </button>

            <button
              onClick={() => window.open('/feedback', '_blank')}
              className="feedback-sidebar__action-btn feedback-sidebar__action-btn--secondary"
            >
              <svg className="feedback-sidebar__action-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              View All Feedback
            </button>
          </div>

          {/* Help & Support */}
          <div className="feedback-sidebar__help">
            <h3 className="feedback-sidebar__help-title">Help & Support</h3>
            <div className="feedback-sidebar__help-list">
              <p>• Submit bug reports for issues</p>
              <p>• Request new features</p>
              <p>• Share general feedback</p>
              <p>• Report model improvements</p>
            </div>
          </div>

          {/* Feedback Types */}
          <div className="feedback-sidebar__types">
            <h3 className="feedback-sidebar__types-title">Feedback Types</h3>
            <div className="feedback-sidebar__types-list">
              <div className="feedback-sidebar__type-item">
                <span>Bug Report - Report issues or errors</span>
              </div>
              <div className="feedback-sidebar__type-item">
                <span>Feature Request - Suggest new features</span>
              </div>
              <div className="feedback-sidebar__type-item">
                <span>Model Improvement - ML model suggestions</span>
              </div>
              <div className="feedback-sidebar__type-item">
                <span>General Feedback - Other comments</span>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="feedback-sidebar__contact">
            <h3 className="feedback-sidebar__contact-title">Contact Information</h3>
            <p className="feedback-sidebar__contact-text">
              For urgent issues or questions, please include your contact information in the feedback form.
            </p>
          </div>
        </div>
      </div>

      {/* Feedback Form Modal */}
      <FeedbackForm
        isOpen={showFeedbackForm}
        onClose={() => setShowFeedbackForm(false)}
        onSubmitSuccess={handleFeedbackSuccess}
      />
    </>
  );
};

export default FeedbackSidebar;

